<template>
  <div class="order_block delivery-block">
    <h3 class="title">Способы доставки</h3>

    <div class="content">
      <standart-radio
          name="delivery"
          :variants="deliveryData.list"
          :current_variant="deliveryData.current"
          @radio_change="delivery_change($event)"
      >
      </standart-radio>

      <div class="delivery-type pickup" v-if="deliveryData.current.id == 'd_19'">
        <span class="type_title">Адреса пунктов самовывоза:
          <hint-button>
            <template v-slot:hint-text>
              Поясняющий текст<br>
              о самовывозе
            </template>
          </hint-button>
        </span>

        <div class="delivery-type-content">

          <div class="pickup_list">
            <div class="pickup-item"
                 v-for="item in deliveryData?.stores" :key="item"
                 :class="[{selected: item.selected}]"
            >
              <div class="location row">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
                  <path d="M13.5 10C13.5 11.933 11.933 13.5 10 13.5C8.067 13.5 6.5 11.933 6.5 10C6.5 8.067 8.067 6.5 10 6.5C11.933 6.5 13.5 8.067 13.5 10Z" stroke="#1B78BC" stroke-width="1.5"/>
                  <path d="M10 1C14.8706 1 19 5.03298 19 9.92577C19 14.8965 14.8033 18.3847 10.927 20.7567C10.6445 20.9162 10.325 21 10 21C9.67495 21 9.35549 20.9162 9.073 20.7567C5.2039 18.3616 1 14.9137 1 9.92577C1 5.03298 5.12944 1 10 1Z" stroke="#1B78BC" stroke-width="1.5"/>
                </svg>
                <span>{{item.location}}</span>
              </div>

              <div class="products row">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M3.16992 7.44L11.9999 12.55L20.7699 7.46997" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 21.61V12.54" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9.9306 2.48L4.59061 5.45003C3.38061 6.12003 2.39062 7.80001 2.39062 9.18001V14.83C2.39062 16.21 3.38061 17.89 4.59061 18.56L9.9306 21.53C11.0706 22.16 12.9406 22.16 14.0806 21.53L19.4206 18.56C20.6306 17.89 21.6206 16.21 21.6206 14.83V9.18001C21.6206 7.80001 20.6306 6.12003 19.4206 5.45003L14.0806 2.48C12.9306 1.84 11.0706 1.84 9.9306 2.48Z" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16.9998 13.24V9.58002L7.50977 4.09998" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>
                Товар:
                <span class="g" v-if="item.products_quantity > 0">{{item.products_quantity}} шт</span>
                <span v-if="item.products_quantity <= 0">{{item.products}}</span>
              </span>
              </div>

              <div class="work_time row">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                  <circle cx="11" cy="11" r="10" stroke="#1B78BC" stroke-width="1.5"/>
                  <path d="M8.5 8.5L11.9999 11.9996M15 7L10 12" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>{{item.work_time}}</span>
              </div>
              <span class="select_store" @click="selectStore(item)">Выбрать склад</span>
            </div>
          </div>
          <div id="map"></div>
          <YandexMap
              :settings="mapSettings" :coordinates="currentMapState.coordinates"
              :zoom="currentMapState.zoom"
              :controls="[]"
              ref="ym"
          >
            <yandex-marker
                v-for="item in deliveryData.stores" :key="item"
                :marker-id="item.id"
                :coordinates="[item.coordinates[0], item.coordinates[1]]"
                type="Point"
                :id="'ymarker_' + item.id"
                :class="[{ymarker: true}]"
            >
              <template v-slot:component>
                <div class="title">{{item.location}}</div>
                <div class="work_time">{{item.work_time}}</div>
                <div><span class="select_store" @click="selectStore(item)">Выбрать склад</span></div>
              </template>
            </yandex-marker>
          </YandexMap>
        </div>
      </div>

      <div class="delivery-type delivery" v-if="deliveryData.current.id == 'd_20'">
        <span class="type_title">Доставка магазина:
            <hint-button>
              <template v-slot:hint-text>
                Поясняющий текст<br>
                о доставке магазина
              </template>
            </hint-button>
        </span>
        <div class="delivery-type-content">
          <dropdown-filed
              c_style=""
              v-show="deliveryData.delivery.addresses.list.length > 1"
              title="Адрес доставки"
              :current='deliveryData.delivery.addresses.current'
              :list='deliveryData.delivery.addresses.list'
              @change="fillAddress($event)"
          >
          </dropdown-filed>
          <standart-filed
              v-show="showNewAddress || deliveryData.delivery.addresses.list.length == 1"
              id="name" title="Новый адрес доставки" type="text" placeholder="Ваш адрес доставки"
              :value="deliveryData.delivery.address" @updated="delivery_address_change($event)"
              :error-text="deliveryData.delivery.address_error"
          >
          </standart-filed>
          <standart-filed
              id="name" title="Дата доставки" type="date" placeholder="Выберите дату доставки "
              :value="deliveryData.delivery.date" @updated="delivery_date_change($event)"
              icon=""
              :error-text="deliveryData.delivery.date_error"
          >
          </standart-filed>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import StandartRadio from "@/components/share/StandartRadio";
import HintButton from "@/components/share/HintButton";
import StandartFiled from "@/components/share/StandartField";
import { YandexMap, YandexMarker } from 'vue-yandex-maps';
import DropdownFiled from "@/components/share/DropdownField";



export default {
  name: 'DeliveryBlock',
  props: {
    deliveryData : Object,
  },
  components: {
    DropdownFiled,
    StandartFiled,
    HintButton,
    StandartRadio,
    YandexMap,
    YandexMarker
  },
  data() {
    return{
      deliveryType : "pickup",

      mapSettings : {
        apiKey: '8f78d238-e4a3-4dd0-9523-13b363ba4362', // Индивидуальный ключ API
        lang: 'ru_RU', // Используемый язык
        coordorder: 'latlong', // Порядок задания географических координат
        debug: false, // Режим отладки
        version: '2.1' // Версия Я.Карт
      },

      currentMapState : {
        zoom: 7,
        coordinates : [54.629221, 39.140111]
      },

      map : null,

      showNewAddress : false
    }
  },
  async mounted() {
   //this.selectStore(this.deliveryData?.stores[0]);
  },
  methods : {
    fillAddress : function(value) {
      if(value != 0) {
        this.$emit("delivery_address_change", this.deliveryData.delivery.addresses.list[value].title);
        this.showNewAddress = false;
      }
      else {
        this.$emit("delivery_address_change", "");
        this.showNewAddress = true;
      }
    },
    selectStore : function(item) {
      this.deliveryData.stores.forEach(function(item) {
        item.selected = false;
      });

      console.log(item);

      item.selected = true;

      this.currentMapState.coordinates = item.coordinates;

      this.$emit("delivery_store_change", item.id);
    },
    delivery_change : function(value) {
      this.$emit("delivery_change", value);
    },
    delivery_address_change : function(value) {
      this.$emit("delivery_address_change", value);
    },
    delivery_date_change : function(value) {
      this.$emit("delivery_date_change", value);
    },
  }
}
</script>

<style scoped>

.delivery-block {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.delivery-block .content {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.delivery-block .content .delivery-type {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.delivery .delivery-type-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pickup .delivery-type-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.delivery-block .content .delivery-type .type_title{
  color: var(--Black, #222);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.pickup-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px;
  border-top: 1px solid var(--Border, #EDEDED);
  margin: 0px -20px;
}

.pickup-item:last-child {
  border-bottom: 1px solid var(--Border, #EDEDED);
}

.pickup-item.selected {
  background: var(--BG, #F8F8F8);
}

.pickup-item .select_store {
  color: var(--Blue, #1B78BC);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  margin-top: 6px;
  padding-bottom: 2px;
  border-bottom: 1px solid var(--Blue, #1B78BC);
  width: max-content;
  cursor: pointer;
}

.pickup-item .row{
  display: flex;
  gap: 8px;
}

.pickup-item .row svg {
  width: 24px;
  height: 24px;
}

.pickup-item .row span {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  margin-top: 2px;
  flex: 1;
}

.pickup-item .row span.g {
  color: var(--Green, #69BE15);
}


/*MOBILE*/
@media (max-width: 1250px)
{
  .delivery-block {
    gap: 12px;
  }

  .delivery-block .content {
    gap: 24px;
  }

  .delivery-block .content .delivery-type {
    gap: 16px;
  }
}
</style>



<style>

.delivery-block .standart-radio .title {
  display: none;
}

.delivery-block .standart-radio .variants {
  display: flex;
  flex-direction: row;
  align-items: start;
  padding: 0px;
  gap: 24px;
}

.delivery-block .hint_button svg path, .delivery-block .hint_button svg circle{
  stroke: #1B78BC;
}

.yandex-container {
  height: 350px;
  border-radius: 8px;
}

.yandex-balloon {
  width: 300px;
  height: 100px;
}

.yandex-balloon .title {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
}

.yandex-balloon .work_time {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
}

.yandex-balloon .select_store {
  color: var(--Blue, #1B78BC);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  margin-top: 6px;
  padding-bottom: 2px;
  border-bottom: 1px solid var(--Blue, #1B78BC);
  width: max-content;
  cursor: pointer;
}

.ymaps-2-1-79-map-copyrights-promo {
  display: none !important;
}

.ymaps-2-1-79-copyright__wrap {
  display: none !important;
}

</style>
